$(document).on('click', function (e) {
    const $body = $('body');

    if (
        $body.hasClass('user-action-visible') &&
        $body.hasClass('login-window-visible') &&
        !$(e.target).closest('.login-widget, .customLoginPopup').length
    ) {
        $body.removeClass('user-action-visible login-window-visible');
    }
});

$(document).on('mouseleave', '#login', function (e) {
    e.stopPropagation();
});